import dayjs from '@/js/libs/dayjs';
export var XDateType;
(function (XDateType) {
    XDateType["X"] = "X";
    XDateType["ISO"] = "ISO";
})(XDateType || (XDateType = {}));
export const DATE_UNIX = 'X';
export const DATE_UNIX_MS = 'x';
export const DATE_ISO = 'YYYY-MM-DD';
export const DATETIME_ISO = 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]';
export const DATETIME_PARSE_ISO = 'YYYY-MM-DDTHH:mm:ss.SSSZ';
export const DATETIME_PARSE_ISO_SHORT = 'YYYY-MM-DDTHH:mm:ssZ';
export const TIME_ISO = 'HH:mm';
const DATETIME_PARSE_FORMATS = [DATETIME_PARSE_ISO, DATETIME_PARSE_ISO_SHORT];
const adjustArrayDate = (value) => {
    const [year, month = 0, ...rest] = value;
    return [year, month - 1, ...rest];
};
export const toTimeType = (m) => {
    if (dayjs.isDayjs(m)) {
        return m.format(TIME_ISO);
    }
    return m;
};
export const fromTimeType = (v) => {
    if (v == null) {
        return v;
    }
    return dayjs.utc(v, TIME_ISO);
};
export const toDateType = (m) => {
    if (dayjs.isDayjs(m)) {
        return m?.format(DATE_ISO);
    }
    return m;
};
export const fromDateType = (v) => {
    if (v == null) {
        return v;
    }
    if (Array.isArray(v)) {
        return dayjs.utc(adjustArrayDate(v));
    }
    return dayjs.utc(v, DATE_ISO);
};
export const fromDateTimeType = (v) => {
    if (v === null)
        return null;
    if (v === undefined)
        return undefined;
    if (Array.isArray(v)) {
        return dayjs.utc(adjustArrayDate(v));
    }
    return dayjs.utc(v, 
    // @ts-expect-error actually dayjs supports array of formats
    typeof v === 'number' ? DATE_UNIX : DATETIME_PARSE_FORMATS);
};
export const toDateTimeType = (m) => {
    if (dayjs.isDayjs(m)) {
        return m.format(DATETIME_ISO);
    }
    return m;
};
export const toDateTimeUnixType = (m) => {
    if (m === null)
        return null;
    if (m === undefined)
        return undefined;
    return +m.format(DATE_UNIX);
};
export const toDateTimeUnixTypeMs = (m) => {
    if (m === null)
        return null;
    if (m === undefined)
        return undefined;
    return +m.format(DATE_UNIX_MS);
};
// As we have only NULL on backend side & typescript has tons of features for `undefined` type, we cast
// backend `null` into frontend `undefined`
export const reviver = (k, v) => {
    if (v === null) {
        return undefined;
    }
    return v;
};
// used for api codegen
export const encodeBody = (body) => {
    if (body && !(body instanceof Array) && !Object.keys(body).length) {
        return undefined;
    }
    if (body && typeof body === 'string') {
        return body;
    }
    return JSON.stringify(body);
};
/**
 * Converts to frontend's internal date format that is understood by apis' toDate.
 * @param date - Common JS Date object.
 * @returns - Internal api date type.
 */
const fromJSDate = (date) => dayjs(date);
/**
 * Converts to frontend's internal dateTime format that is understood by apis' toDateTime.
 * @param date - Common JS Date object.
 * @returns - Internal api datetime type.
 */
const fromJSDateTime = fromJSDate;
/**
 * Formats JS date (using day.js currently).
 * @param date - JS date to format
 * @param format - Format to use
 * @returns formatted date as string
 */
const formatJSDate = (date, format) => fromJSDate(date).format(format);
/**
 * Converts from internal date format  to JS Date format.
 * @param date - JS date in internal format (day.js currently)
 * @returns passed date as JS date
 */
const toJSDate = (date) => date.toDate();
/**
 * Parses string date format to internal date format (day.js currently).
 * @param dateAsString - String date to parse
 * @param format - Format to use
 * @returns date in internal format (day.js currently)
 */
const parseDate = (dateAsString, format) => dayjs(dateAsString, format);
/**
 * Parses string date format to JS date format.
 * @param dateAsString - Stringified date to parse
 * @param format - Format to use to parse the date
 * @returns JS date
 */
const parseJSDate = (dateAsString, format) => toJSDate(parseDate(dateAsString, format));
export { fromJSDate, fromJSDateTime, toJSDate, formatJSDate, parseJSDate, parseDate };
